export default __webpack_public_path__ + "static/media/teamgrid.b719a9e1.svg";